var render = function render(){var _vm=this,_c=_vm._self._c;return (false)?_c('div',{staticClass:"d-flex flex-column",staticStyle:{"gap":"4px"}},[_c('v-btn',{on:{"click":_vm.connectFacebook}},[_vm._v("connectFacebook")]),_c('v-btn',{on:{"click":_vm.changeLongLiveToken}},[_vm._v("changeLongLiveToken")]),_c('v-btn',{on:{"click":_vm.getMe}},[_vm._v("getMe")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }